import { z } from 'zod';

/** Droits effectifs de l’utilisateur courant sur un document (règles spécifiques actives / période). */
export const documentAccessDtoSchema = z.object({
  redaction: z.boolean(),
  validation: z.boolean(),
  consultation: z.boolean(),
});

export type DocumentAccessDto = z.infer<typeof documentAccessDtoSchema>;
